import { iconExternalLink, iconShop } from '@hover/icons';
import { assertUnreachable } from '@hover/utilities';

import {
  DESIGNER_PRODUCT_PROVIDER_MAP,
  DesignerProductProvider,
  MaterialCalloutType,
} from 'src/modules/homeownerApp/constants/productProviders/configuration';
import { PROVIDER_PRODUCT_MAP } from 'src/modules/homeownerApp/constants/productProviders/products';
import { warn } from 'src/modules/homeownerApp/helpers/logging';
import { getApiEnvironment } from 'src/shared/utils/environment';

const getProductProvider = (providerUuid: string | undefined) => {
  const environment = getApiEnvironment();

  if (!environment) {
    warn(
      'getProductProvider: unable to determine API environment required to retrieve product provider configuration',
    );
    return null;
  }

  const map = DESIGNER_PRODUCT_PROVIDER_MAP[environment];

  if (!map) {
    warn(
      `getProductProvider: no product provider configuration found for environment "${environment}"`,
    );
    return null;
  }

  if (!providerUuid) return null;

  return map[providerUuid] ?? null;
};

export const getProductProviderConfiguration = (
  providerUuid: string | undefined,
) => {
  const provider =
    getProductProvider(providerUuid) || DesignerProductProvider.GENERIC;

  return PROVIDER_PRODUCT_MAP[provider];
};

export const getMaterialCalloutDisplay = (type: MaterialCalloutType) => {
  switch (type) {
    case MaterialCalloutType.SHOP:
      return {
        icon: iconShop,
        i18nKey: 'materialCallouts.calloutButton.shop' as const,
      };
    case MaterialCalloutType.APPOINTMENT:
      return {
        icon: iconExternalLink,
        i18nKey: 'materialCallouts.calloutButton.appointment' as const,
      };
    case MaterialCalloutType.QUOTE:
      return {
        icon: iconExternalLink,
        i18nKey: 'materialCallouts.calloutButton.getQuote' as const,
      };
    case MaterialCalloutType.NONE:
      return {
        icon: iconShop,
        i18nKey: 'materialCallouts.calloutButton.shop' as const,
      };
    default:
      return assertUnreachable(type);
  }
};
